import type { AudioLayer, Layer, PieceModel } from './types';

// Visual layers in draw order, from back to front, matching the canvas stack.
export const getVisualLayers = (model: PieceModel): Layer[] =>
  model.layerOrder.map(id => model.layers[id]).filter((layer): layer is Layer => Boolean(layer));

// Audio tracks are kept outside the visual stack and rendered separately in the timeline.
export const getAudioLayers = (model: PieceModel): AudioLayer[] =>
  Object.values(model.layers).filter((layer): layer is AudioLayer => layer.kind === 'audio');

// Returns whether the piece contains time-based content such as audio,
// animations, or fixed-duration clips.
// Used to decide whether to show the timeline and export the piece as video.
export const hasTemporalContent = (model: PieceModel): boolean => {
  for (const layer of Object.values(model.layers)) {
    if (layer.kind === 'audio') return true;
    if (layer.enter || layer.exit || layer.fit === 'fixed') return true;
  }
  return false;
};
